export default __webpack_public_path__ + "static/media/head_HAP.21e0f5be.svg";